import React, { useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button,Row,Col } from "react-bootstrap";
import { ArrowLeftCircle, Download} from "react-bootstrap-icons";
import AxiosInstance from '../AxiosInstance';
import Pagination from '../Pagination'; 
import Layout from './Layout';
const MissingDocs = () => {
    const navigate = useNavigate();
  
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;

    const fetchMissingDocs = async () => {
        setError(null);

        try {
            const response = await AxiosInstance.get('/admin/missing-docs');
            setData(response.data);
            setCurrentPage(1);
        } catch (err) {
            setError('Failed to fetch missing documents.');
        } 
    };

    const downloadCSV = async () => {
        try {
            const response = await AxiosInstance.get('/admin/missing-docs-report', { responseType: 'blob' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', 'missing_documents_report.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            setError('Failed to download the CSV report.');
        } 
    };

    useEffect(() => {
        fetchMissingDocs();
    }, []);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentData = data.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(data.length / recordsPerPage);

    return (
        <Layout heading="Missing Documents List">
            {error && <p className="text-danger">{error}</p>}
            <Row className="mb-3 align-items-center">
                <Col xs={6} className="d-flex justify-content-start">
                    <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
                        <ArrowLeftCircle />
                    </Button>
                </Col>
                <Col xs={6} className="d-flex justify-content-end">
                    <Button
                    className="btn btn-secondary px-3 py-2"
                    style={{ color: "white", minWidth: "auto" }}
                    onClick={downloadCSV}
                    >
                    <Download className="me-2" />
                    .csv
                    </Button>
                </Col>
            </Row>
            <div className="d-block d-md-none" style={{ overflowY: "auto", height: "300px" }}>
                 <div className="table-responsive">
                    <table className="table table-hover text-center align-middle table-striped">
                        <thead className="table-primary">
                            <tr>
                                <th>#</th>
                                <th className="text-start">Employee Code</th>
                                <th className="text-start">Name</th>
                                <th className="text-start">Email</th>
                                <th className="text-start">Documents</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-muted">No missing documents found.</td>
                                </tr>
                            ) : (
                                currentData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{indexOfFirstRecord + index + 1}</td>
                                        <td className="text-start">{item.employeeCode}</td>
                                        <td className="text-start">{item.fullName}</td>
                                        <td className="text-start">{item.email}</td>
                                        <td className="text-start text-truncate" style={{ maxWidth: "300px" }}>
                                            {Array.isArray(item.missingDocuments)
                                                ? item.missingDocuments.join(', ')
                                                : item.missingDocuments || <span className="text-muted">N/A</span>}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div className="table-responsive d-none d-md-block">
                 <div className="table-responsive">
                    <table className="table table-hover text-center align-middle table-striped">
                        <thead className="table-primary">
                            <tr>
                                <th>#</th>
                                <th className="text-start">Employee Code</th>
                                <th className="text-start">Name</th>
                                <th className="text-start">Email</th>
                                <th className="text-start">Documents</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-muted">No missing documents found.</td>
                                </tr>
                            ) : (
                                currentData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{indexOfFirstRecord + index + 1}</td>
                                        <td className="text-start">{item.employeeCode}</td>
                                        <td className="text-start">{item.fullName}</td>
                                        <td className="text-start">{item.email}</td>
                                        <td className="text-start text-truncate" style={{ maxWidth: "300px" }}>
                                            {Array.isArray(item.missingDocuments)
                                                ? item.missingDocuments.join(', ')
                                                : item.missingDocuments || <span className="text-muted">N/A</span>}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
            />
        </Layout>
    );
};

export default MissingDocs;
